import React, { useRef, useState } from 'react'
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useForm } from 'react-hook-form';
import ApiHelper from '../../helperFunction/ApiHelper';
import API_ENDPOINTS from '../../helperFunction/Constant';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Toast } from 'primereact/toast';

const ResetPassword = () => {

    const toast = useRef(null)
    const navigate = useNavigate()

    const { token } = useParams()

    const [showPasswordOne, setShowPasswordOne] = useState(false);
    const [showPasswordTwo, setShowPasswordTwo] = useState(false);

    const schema = yup.object({
        password: yup.string().required("Password is required"),
        confirmPassword: yup.string().required("Confirm Password is required")
    });

    const { register, handleSubmit, reset, formState: { errors }, } = useForm({ resolver: yupResolver(schema), });

    const onSubmit = (data) => {
        ApiHelper.post(`${API_ENDPOINTS.RESET_PASSWORD}/${token}`, data).then((res) => {
            if (res.status === 200) {
                toast.current.show({ severity: 'success', summary: 'Success', detail: res.data.message, life: 3000 })
                reset()
                setTimeout(() => {
                    navigate('/login')
                }, 1000)
            }
        }).catch((errors) => {
            toast.current.show({ severity: 'error', summary: 'Error', detail: errors.response.data.message, life: 3000 })
        })
    };

    return (
        <>
            <Toast ref={toast} />
            <div class="container-xxl">
                <div class="authentication-wrapper authentication-basic container-p-y">
                    <div class="authentication-inner">
                        <div class="card">
                            <div class="card-body">
                                <div class="app-brand justify-content-center">
                                    <Link to="/" class="app-brand-link gap-2">
                                        <span class="app-brand-logo demo">
                                            <img src="/img/logo-light.png" width="200px" />
                                        </span>
                                    </Link>
                                </div>
                                <p class="mb-3">Please Enter new password</p>
                                <form className="mb-3" onSubmit={handleSubmit(onSubmit)}>
                                    <div className="mb-1 form-password-toggle mb-2">
                                        <label htmlFor="password" className="form-label"> Password </label>
                                        <div className="input-group">
                                            <input type={showPasswordOne ? "text" : "password"} className="form-control" id="password" placeholder="********" {...register("password")} />
                                            <button type="button" className="btn btn-outline-secondary" onClick={() => setShowPasswordOne(!showPasswordOne)}>
                                                <i className={`bi ${showPasswordOne ? "bi-eye-slash" : "bi-eye"}`}></i>
                                            </button>
                                        </div>
                                        {errors.password && (<small className="text-danger"> {errors.password.message} </small>)}
                                    </div>
                                    <div className="mb-1 form-password-toggle mb-3">
                                        <label htmlFor="password" className="form-label">Confirm Password </label>
                                        <div className="input-group">
                                            <input type={showPasswordTwo ? "text" : "password"} className="form-control" id="password" placeholder="********" {...register("confirmPassword")} />
                                            <button type="button" className="btn btn-outline-secondary" onClick={() => setShowPasswordTwo(!showPasswordTwo)}>
                                                <i className={`bi ${showPasswordTwo ? "bi-eye-slash" : "bi-eye"}`}></i>
                                            </button>
                                        </div>
                                        {errors.confirmPassword && (<small className="text-danger"> {errors.confirmPassword.message} </small>)}
                                    </div>
                                    <button className="btn btn-primary d-grid w-100" type="submit" > Send </button>
                                    <div class="text-center mt-3">
                                        <Link to="/login" class="d-flex align-items-center justify-content-center">
                                            <i class="bx bx-chevron-left scaleX-n1-rtl bx-sm"></i>
                                            Back to login
                                        </Link>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ResetPassword
